import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-start-revise',
  templateUrl: './start-revise.component.html',
  styleUrls: ['./start-revise.component.css']
})
export class StartReviseComponent implements OnInit {

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<StartReviseComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    setTimeout(() => { 
      this.dialogRef.close(true);
    }, 4000);
  }

}
